import React from "react";

function ViewIcon({ onView }) {
  const handleClick = () => {
    onView();
  };
  return (
    <button
      type="button"
      className=" btn-label-primary shadow-none me-1"
      onClick={handleClick}
    >
      <i className="lni lni-eye"></i>
    </button>
  );
}

export default ViewIcon;
